/** Normal sessions persist across tabs; local test actors belong to one tab. */
let sessionVersion = 0;
export const authSessionVersion = () => sessionVersion;
export const invalidateAuthSession = () => { sessionVersion += 1; };

const TAB_SESSION = 'etappio-local-test-session';
const authKeys = ['accessToken', 'refreshToken', 'token', 'impersonationToken', 'sessionIdleExpiresAt', 'sessionEndReason'];
const activeStorage = () => sessionStorage.getItem(TAB_SESSION) === 'true' ? sessionStorage : localStorage;

export const authStorage = {
  getItem: (key: string) => activeStorage().getItem(key),
  setItem: (key: string, value: string) => activeStorage().setItem(key, value),
  removeItem: (key: string) => activeStorage().removeItem(key)
};

export function setAuthSessionScope(scope: 'browser' | 'tab') {
  invalidateAuthSession();
  for (const key of authKeys) sessionStorage.removeItem(key);
  if (scope === 'tab') sessionStorage.setItem(TAB_SESSION, 'true');
  else sessionStorage.removeItem(TAB_SESSION);
}
